import callApi, { CallApiResult } from 'src/api';
import { CartOfferRequestDTO } from 'src/entities/cart/request/CartOfferRequestDTO';

/**
 * Submit Offer API Request
 */
export const submitOffer = (data: CartOfferRequestDTO): Promise<CallApiResult> => {
    return callApi('/api/officeProfiOrder/offer', { method: 'PUT', data });
};

/**
 * Submit Offer API Request
 */
export const submitAndPayOffer = (data: CartOfferRequestDTO): Promise<CallApiResult> => {
    return callApi('/api/officeProfiOrder/offerAndPay', { method: 'PUT', data });
};

export const fetchOfferPaymentStatus = async (orderId: string): Promise<boolean> => {
    const response = await callApi(`/api/officeProfiOrder/${orderId}/paymentStatus`);
    return Boolean(response?.response?.data);
};

/**
 * Fetch my offers
 */
export const fetchMyOffers = (): Promise<CallApiResult> => {
    return callApi('/api/officeProfiOrder/current/myOffers');
};

/**
 * Fetch offers
 */
export const fetchOffers = (): Promise<CallApiResult> => {
    return callApi('/api/officeProfiOrder/current/offers');
};
